import { type MutationOptions, useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import UrlShortenerRepository from '@/repositories/UrlShortenerRepository';
import { ShortenedLink } from '@/types/urlShortener';

export const useShortenLink = (options?: MutationOptions<ShortenedLink, AxiosError, string>) => {
  const urlShortenerRepository = UrlShortenerRepository();

  return useMutation({
    mutationFn: (originalLink: string) => urlShortenerRepository.shortenLink(originalLink),
    ...options
  });
};
